import { render } from "./test-item.vue?vue&type=template&id=7319aaac&scoped=true"
import script from "./test-item.vue?vue&type=script&lang=js"
export * from "./test-item.vue?vue&type=script&lang=js"

import "./test-item.vue?vue&type=style&index=0&id=7319aaac&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\shview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7319aaac"]])

export default __exports__